
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'CompetitorIcon',
  props: {
    competitorId: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 16
    }
  },

  data() {
    return {
      currentExtensionIndex: 0,
      extensions: ['png', 'webp']
    };
  },

  watch: {
    competitorId() {
      // Reset dell'indice quando cambia il competitorId
      this.currentExtensionIndex = 0;
    }
  },

  methods: {
    getIconPath(competitorId: string) {
      // Controlla se ha icon_id (sport dallo store) o solo icon (sport di fallback/sottomenu)
      if (competitorId) {
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisCompetitors/${competitorId}.png`
        );
      } else {
        // Fallback generico
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisCompetitors/team-1.webp`
        ); // tennis
      }
    },
    handleImageError(event: any) {
      const competitorId = this.competitorId || 'team-1';
      const currentExtension = this.extensions[this.currentExtensionIndex];

      // Prova la prossima estensione disponibile
      if (this.currentExtensionIndex < this.extensions.length - 1) {
        this.currentExtensionIndex++;
        const nextExtension = this.extensions[this.currentExtensionIndex];
        event.target.src =
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/illinoisCompetitors/${competitorId}.${nextExtension}`;
      } else {
        // Se tutte le estensioni sono fallite, usa il fallback generico
        const randomNumber = Math.floor(Math.random() * 6) + 1;
        event.target.src =
          process.env.VUE_APP_URL_CLOUDFRONT +
          '/svg/illinoisCompetitors/team-' +
          randomNumber +
          '.webp';
      }
    }
  }
});
